import darkLogo from "../assets/png/dark-logo.png"

type Props = {
  width?: string | number
  height?: string | number
  className?: string
  onClick?: () => void
  style?: React.CSSProperties
}

export const LoversLiveForeverLogo = ({
  width = "300px",
  height = "auto",
  className = ""
}: Props) => {
  return (
    <img
      src={darkLogo}
      width={width}
      height={height}
      className={className}
      alt="lovers live forever logo"
    />
  )
}
